import { Link } from "react-router-dom";
import { XCircle, Wrench } from "lucide-react";

export default function BillingCancelled() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-midnight to-midnight-2 px-6">
      <div className="w-full max-w-md rounded-2xl bg-card p-8 text-center shadow-xl">
        <div className="mb-5 flex items-center justify-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-midnight"><Wrench className="h-4 w-4 text-brand" /></div>
          <span className="font-display text-lg font-bold tracking-widest text-midnight">PRO GARAGES</span>
        </div>
        <XCircle className="mx-auto mb-3 h-14 w-14 text-muted-foreground" />
        <h1 className="font-display text-3xl font-bold uppercase text-midnight">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-muted-foreground">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/billing" data-testid="cancelled-billing-btn" className="mt-6 inline-block w-full rounded-lg bg-brand py-3.5 text-sm font-extrabold tracking-widest text-white">VIEW PLANS</Link>
        <Link to="/dashboard" className="mt-3 inline-block text-sm font-semibold text-brand-2">Back to dashboard</Link>
      </div>
    </div>
  );
}
